import script from "./EditEnergyEfficiencyRatingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditEnergyEfficiencyRatingModal.vue?vue&type=script&setup=true&lang=js"

import "./EditEnergyEfficiencyRatingModal.vue?vue&type=style&index=0&id=80afd924&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80afd924"]])

export default __exports__